import { useEffect, useMemo, useState } from 'react'
import { StateSliderCSS } from './StateSliderCSS.styled'
import { motion } from 'framer-motion'
import { v4 as uuid } from 'uuid'

export const StateSlider = ({ className, stateOptions, onSelection, title }) => {
  const [activeState, setActiveState] = useState(stateOptions.at(0))

  const selectState = (state) => {
    setActiveState(state)
    onSelection && onSelection(state)
  }

const layoutId = useMemo(()=>uuid(),[])

  return (
    <StateSliderCSS className={className} statesLength={stateOptions?.length||0}>
      <div className='container'>
        <p className='title'>{ title}</p>
        <ul className='track'>
          {stateOptions.map((state, idx) => (
            <li key={`3sts${idx}`} className='stateOptionContainer' onClick={() => selectState(state)} >
              {activeState.name === state.name && (
                <motion.div className='stateOption active_bg' layoutId={layoutId}></motion.div>
              )}
              <div className={`stateOption ${activeState.name === state.name ? 'active' : ''}`}>{state.name}</div>
            </li>
          ))}
        </ul>
      </div>
    </StateSliderCSS>
  )
}
